// extracted by mini-css-extract-plugin
module.exports = {"container":"noAccess_container__Fam5L","title":"noAccess_title__50FiZ"};